import { Component, Input } from "@angular/core";

@Component({
    selector: 'data-list',
    templateUrl: './data-list.html',
    styleUrls: ['../../legacy-component.component.css']
  })
  
  export class DataList {
    @Input() item;
    @Input() k = 0;
    @Input() active = false;
    @Input() parent = null;
  
    constructor() { }
  
    select(item) {
      if (parent) {
        this.parent.select(item);
      }
    }
  
    confirm(t,e) {
      if (parent) {
        this.parent.confirm(t,e);
      }
    }
  
    getFloors(data) {
      if (parent) {
        if (data.entity_type == 'property') {
          this.parent.getFloors('legacy', data);
        } else {
          this.parent.getFloors('existing', data);
        }
  
      }
    }
    getUnits(data) {
      if (data.entity_type == 'property_floor') {
        if (parent) {
          this.parent.getUnits(data);
        }
      }
      if (data.entity_type == 'property_floor_existing') {
        if (parent) {
          this.parent.getUnits(data);
        }
      }
    }
  }